import { useQuery } from '@tanstack/react-query';
import { formBuilderApi, formBuilderKeys } from '@/features/quote-and-apply-builder';

export function useFormConfig(formId: string) {
  return useQuery({
    queryKey: formBuilderKeys.detail(formId),
    queryFn: () => formBuilderApi.getFormById(formId),
    enabled: !!formId,
    staleTime: Infinity,
    refetchOnMount: false,
  });
}
